import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/salesSaga";

export const UpdateBtns = () => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.staffSales.filtersDirty);
  const isLoading = useSelector((state) => state.staffSales.isLoading);

  return filtersDirty && !isLoading ? (
    <>
      <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
        Update
      </button>

      <button className="submit reset" onClick={() => dispatch(actionCreators.resetData())}>
        Reset
      </button>
    </>
  ) : null;
};
